export default "__VITE_ASSET__BIjg4nEC__"